module.exports = __webpack_public_path__ + "static/media/21.738d44fe.svg";